import { safeStorageGet, safeStorageSet } from './safeStorage';

const CONSENT_STORAGE_KEY = 'cookie_consent_v1';

export const CONSENT_CHANGED_EVENT = 'analyticsConsentChanged';
export const OPEN_COOKIE_SETTINGS_EVENT = 'openCookieSettings';

let sessionConsent = null;
let cachedConsent;

export const isAnalyticsEnabledByEnv = () =>
  process.env.NODE_ENV === 'production' ||
  String(process.env.REACT_APP_ENABLE_ANALYTICS).toLowerCase() === 'true';

export const isAdminPath = (pathname) =>
  String(pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '')).startsWith('/admin');

const parseConsent = (raw) => {
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    return {
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
      decidedAt: parsed.decidedAt || null
    };
  } catch (error) {
    return null;
  }
};

export const getStoredConsent = () => {
  if (cachedConsent !== undefined) {
    return cachedConsent;
  }

  let storageReadable = true;
  const raw = safeStorageGet(CONSENT_STORAGE_KEY, () => {
    storageReadable = false;
  });

  if (!storageReadable) {
    return sessionConsent;
  }

  cachedConsent = parseConsent(raw) ?? sessionConsent;
  return cachedConsent;
};

export const saveConsent = ({ analytics, marketing }) => {
  const consent = {
    analytics: Boolean(analytics),
    marketing: Boolean(marketing),
    decidedAt: new Date().toISOString()
  };

  sessionConsent = consent;
  cachedConsent = consent;
  safeStorageSet(CONSENT_STORAGE_KEY, JSON.stringify(consent));

  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: consent }));
  return consent;
};

export const hasAnalyticsConsent = () => Boolean(getStoredConsent()?.analytics);

export const hasMarketingConsent = () => Boolean(getStoredConsent()?.marketing);

export const needsConsentDecision = () => getStoredConsent() === null;

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === CONSENT_STORAGE_KEY) {
      cachedConsent = undefined;
      sessionConsent = null;
      window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: getStoredConsent() }));
    }
  });
}

export const __testing = {
  __resetSessionConsent: () => {
    sessionConsent = null;
    cachedConsent = undefined;
  },
  __clearCachedConsent: () => {
    cachedConsent = undefined;
  }
};
